export default __webpack_public_path__ + "static/media/deal-with-expert.5b6b042d.png";